import { denormalize } from "normalizr";
import { get } from "lodash";

import { receivableEntry } from "../../../api/schema";

export default state => {
  try {
    const items = get(state, ["debtor", "receivablesEntries", "ids"]);
    const denormalized = denormalize(
      { items },
      { items: [receivableEntry] },
      state.entities
    );
    return denormalized.items || [];
  } catch (err) {
    return [];
  }
};
